<template>
  <div>
    <CRow v-if="(acceptanceStatus.includes(productStatus)) ? true : false">
      <CCol lg="12">
        <CButton size="sm" color="linkedin" name="linkedin" @click="showAddModal">
          <i class="fa fa-plus-square"></i>&nbsp;
          <span>Add Images</span>
        </CButton>
      </CCol>
    </CRow>

    <CRow>
      <CCol lg="12">
        <GlobalTable
          :title="'Product Assets'"
          :fields="fields"
          :items="items"
          :removeButton="(acceptanceStatus.includes(productStatus)) ? true : false"
          :redirectDetail="false"
          :enableAddButton="false"
          :isLoading="isLoading"
          :withCard="false"
           @removeData="removeData"
           @previewImage="previewImage"
        ></GlobalTable>
      </CCol>
    </CRow>

    <CModal
      title="Modal title"
      color="success"
      size="xl"
      :closeOnBackdrop="false"
      :show.sync="addModal"
    >
      <template #header>
        <h6 class="modal-title">Upload Images</h6>
      </template>
      <Loading v-if="isLoading"></Loading>

      <div v-else>
        <CForm>
          <CRow>
            <CCol lg="3">
              <div class="product-group">
                <label for="upload_type">Upload Type</label>
                <model-select
                  class="form-control"
                  id="upload_type"
                  :options="formImagesOptions"
                  v-model="$v.uploadImageForm.upload_type.$model"
                  :isError="$v.uploadImageForm.upload_type.$invalid"
                  @input="changeImageOptions"
                  placeholder="-- Harap pilih salah satu --"
                ></model-select>
                <div
                  v-if="$v.uploadImageForm.upload_type.$invalid"
                  class="invalid-feedback-custom"
                >
                  Upload Type should be filled.
                </div>
              </div>
            </CCol>
          </CRow>
            <br/>
          <template v-if="uploadImageForm.upload_type == '1'">
            <CRow>
                <CCol lg="3">
                <CInputFile
                    ref="fileupload"
                    label
                    accept="image/*"
                    invalid-feedback="Name should be filled"
                    required
                    @change="onFileChange"
                />

                <CInput
                    :type="'hidden'"
                    required
                    v-model="$v.uploadImageForm.images.$model"
                    :is-valid="!$v.uploadImageForm.images.$invalid"
                ></CInput>
                </CCol>
            </CRow>
          </template>
        
        <template v-if="uploadImageForm.upload_type == '2'">
          <CRow>
            <CCol lg="3">
              <CInput
                label="URL Video"
                invalid-feedback="Please put your url video here"
                required
                v-model="$v.uploadImageForm.url_video.$model"
                :is-valid="!$v.uploadImageForm.url_video.$invalid"
              />
            </CCol>
          </CRow>
        </template>
        </CForm>
      </div>

        <template #footer>
          <CButton @click="cancelForm" v-if="!isLoading" color="danger">
            <i class="fa fa-undo"></i>
            Cancel
          </CButton>
          <CButton @click="submitForm" :disabled="$v.uploadImageForm.$invalid || isLoading" color="success">
            <i class="fa fa-save"></i>
            Save Assets
          </CButton>
        </template>

    </CModal>

    <CModal
      title="Image Preview"
      color="success"
      size="lg"
      :closeOnBackdrop="false"
      :show.sync="previewImages"
    >
      <CImg :src="'https://storage.googleapis.com/isikulkas/'+selectedImages+'?r='+unixTime" :thumbnail="true" />
    
    </CModal>

  </div>

</template>

<script>
import axios from "axios";
import tableInterfaces from "@/templates/_table_interfaces.js";
import Loading from "@/templates/Loading";
import GlobalTable from "@/templates/Table";

import { required } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";

export default {
  name: "UploadImage",
  components: { Loading, GlobalTable },
  data() {
    return {
      title: "Upload Image",
      items: [],
      isLoading: false,
      image: null,
      activeTab: 0,
      preview: false,
      isEdit: false,
      unixTime: Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0,
      addModal: false,
      previewImages: false,
      selectedImages: null,
      formImagesOptions: [
        { value: 1, text: "Images" },
        { value: 2, text: "Videos" },
      ],
      uploadImageForm: tableInterfaces.upload_images_product,
      fields: [
        { key: "product_image", label: "URL", sorter: true },
        { key: "flag", label: "Url Type", sorter: true },
        { key: "action", _classes: "text-center action" },
      ],
      acceptanceStatus: ['2','7']
    };
  },
  validations() {
    if(this.uploadImageForm.upload_type === 1) {
     return {
        uploadImageForm: {
            upload_type: { required },
            images: { required },
            url_video: {  }
        }
     }
    } else {
     return {
        uploadImageForm: {
            upload_type: { required },
            images: {  },
            url_video: { required }
        }
     }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  props: {
    products: {
      type: [Array, Object],
      default: () => [],
    },
    productStatus: {
      type: String,
      default: null,
    },
  },
  methods: {
    init: function () {
      this.unixTime = Math.floor(Math.random() * (0 - 9999999999 + 1)) + 0;
    },
    back: function () {
      this.$router.go(-1);
    },
    resetForm: function () {
      for (var i in tableInterfaces.upload_images_product) {
        tableInterfaces.upload_images_product[i] = null;
      }
      this.uploadImageForm = tableInterfaces.upload_images_product;
    },
    showAddModal: function () {
      this.addModal = true;
      this.resetForm();
    },
    previewForm: function () {
      this.preview = true;
      this.isEdit = false;
      this.addButton = false;
    },
    submitForm: function (evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin merubah Data ini ?")) {
        //console.log(this.products);
        this.isLoading = true;
        this.uploadImageForm.id = this.products.id;
        this.uploadImageForm.category = this.products.category;

        this.axios
          .post("console/products/assets", this.uploadImageForm)
          .then((response) => {
            this.addModal = false;
            this.resetForm();
            this.showInfoNotification({
              title: "Ubah Product Image",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Image");
          })
          .finally(() => {
            this.getProductAsset();
          });
      }
    },
    cancelForm: function () {
      this.addModal = false;
    },
    onFileChange(e) {
      this.createImage(e[0]);
    },
    createImage(file) {
      var image = new Image();
      var reader = new FileReader();
      var vm = this;
      reader.onload = (e) => {
        vm.image = e.target.result;
        this.uploadImageForm.images = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    changeImageOptions: function (val) {
     if(val === 1 ) {
        this.uploadImageForm.url_video = null;
     } else {
        this.uploadImageForm.images = null;
     }
    },
    getProductAsset: function () {
      this.isLoading = true;
      this.axios
          .get("console/products/assets/"+this.products.product_code)
          .then((response) => {
            this.items = response.data.data;
            this.resetForm();
            this.showInfoNotification({
              title: "Ubah Product Image",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Image");
          })
          .finally(() => {
            this.isLoading = false;
            let route = this.$route.path.split("/");
            this.init(route[4]);
          });
    },
    removeData: function(e) {
      if (confirm("Apakah anda ingin merubah menghapus assets ini ?")) {
        this.isLoading = true;
        this.axios
          .delete("console/products/remove-asset/"+e.id)
          .then((response) => {
            this.getProductAsset();
            this.showInfoNotification({
              title: "Ubah Product Image",
              message: response.data.message,
            });
          })
          .catch((error) => {
            this.expired(error, "Ubah Product Image");
          })
          .finally(() => {
            this.getProductAsset();

          });
       }
    },
    previewImage: function(img){
     // console.log(img);
      this.selectedImages = img.url;
      this.previewImages = true;
    }
  },
  mounted() {
    this.getProductAsset();
  },
};
</script>
